import React, { useContext, useState } from 'react';
import { Link, Mechanic, StateContext } from '../../StateContext';
import './mechanicList.css';
import ExpandableRow from '../../General/ExpandableRow';
import ExpendableBox from '../../General/ExpandableBox';
import { IContextData } from '../../../App';
import {
    deleteLink,
    deleteMechanicCall,
} from '../../Services/APICalls/apicalls';
import { MechanicTypes, getMechanicTypeLabel } from '../../Services/types';
import EditMechanic from './editMechanic';
import ConnectProject from './connectProject';
import LinkView from '../../General/Links/linkView';
import { useLanguage } from '../../Services/LanguageContext';
import FilterMechanicList from './filterMechanicList';

const MechanicList = () => {
    const { loginData, setLoginData } = useContext<IContextData>(StateContext);
    const { t, language } = useLanguage();
    const [query, setQuery] = useState('');

    let mechanics = (loginData.mechanics as Mechanic[]).filter((mechanic) =>
        mechanic.name.toLowerCase().includes(query.toLowerCase())
    );

    const renderButtons = (m: Mechanic) => (
        <React.Fragment>
            <ConnectProject id={m.id} />
            <EditMechanic id={m.id} name={m.name} about={m.about} />
        </React.Fragment>
    );

    const sortByMechanicName = (a, b) => a.name.localeCompare(b.name);

    return (
        <div className='w-100'>
            <FilterMechanicList query={query} setQuery={setQuery} />
            {mechanics.sort(sortByMechanicName).map((m) => (
                <ExpandableRow Title={m.name}>
                    <div className='flex justify-center w-100'>
                        <ExpendableBox
                            type={getMechanicTypeLabel(m.type, language)}
                            about={m.about}
                            name={m.name}
                            id={m.id}
                            mechanic={m}
                            onDelete={() => deleteMechanicCall(m, setLoginData)}
                            renderButtons={renderButtons(m)}
                        >
                            <div className='flex flex-col px-10 text-base gap-1'>
                                <div className='text-lg font-bold'>
                                    {t('projects')}
                                </div>
                                {m.links.map((x) => (
                                    <LinkView link={x} project={x.project} />
                                ))}
                            </div>
                        </ExpendableBox>
                    </div>
                </ExpandableRow>
            ))}
        </div>
    );
};

export default MechanicList;
